/* eslint-disable react/jsx-no-constructed-context-values */
import {
  createContext,
  SetStateAction,
} from 'react';

export type Breadcrumb = {
  label?: string;
  force?: boolean;
  path?: string;
  parentPath?: string;
  uniquePath?: string;
  index?: boolean;
};

export type BreadcrumbsContextType = {
  breadcrumbs: Breadcrumb[];
  setBreadcrumbs: (value: SetStateAction<Breadcrumb[]>) => void;
};

export const BreadcrumbsContext = createContext<BreadcrumbsContextType>({
  breadcrumbs: [],
  setBreadcrumbs: () => [],
});
